export default "__VITE_ASSET__IF8A9eoD__"